import { DEFAULT_TITLE } from '../const'

export const prestacoes = [
  {
    name: 'prestacao_contas',
    path: '/prestacao_contas',
    component: () => import('@/views/public/prestacao_contas/'),
    meta: {
      title: `${DEFAULT_TITLE} | Prestação de Contas`
    }
  },
  {
    name: 'prestacao_areas',
    path: '/prestacao_contas/areas',
    component: () => import('@/views/public/prestacao_contas/PorArea'),
    meta: {
      title: `${DEFAULT_TITLE} | Prestações por área`
    }
  },
  {
    name: 'prestacao_lista_entidades',
    path: '/prestacao_contas/entidades/:area?',
    component: () => import('@/views/public/prestacao_contas/ListaEntidades'),
    meta: {
      title: `${DEFAULT_TITLE} | Prestações por entidade`
    }
  },
  {
    name: 'prestacao_detalhe_entidade',
    path: '/prestacao_contas/detalhes/:nomeEntidade',
    component: () => import('@/views/public/prestacao_contas/DetalheEntidade'),
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes da entidade`
    }
  },
  {
    name: 'prestacao_detalhe',
    path: '/prestacao_contas/prestacao/:codigo',
    component: () => import('@/views/public/prestacao_contas/DetalhePrestacao'),
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes da prestação`
    }
  },
  {
    name: 'prestacao_todas_entidades',
    path: '/prestacao_contas/todas-entidades',
    component: () =>
      import('@/views/public/prestacao_contas/ListarTodasEntidades'),
    meta: {
      title: `${DEFAULT_TITLE} | Lista de entidades`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/prestacao.js